import { Box, Input, InputGroup, InputRightElement } from "@chakra-ui/react";
import { CalendarIcon } from "@chakra-ui/icons";
import ReactDatePicker from "react-datepicker";

const DatePicker2 = ({ selectedDate, onChange, ...props }) => {
  return (
    <>
      <InputGroup className="dark-theme">
        <ReactDatePicker
          selected={selectedDate}
          onChange={onChange}
          customInput={<Input />}
          dateFormat="MM/dd/yyyy"
          {...props}
        />
        <InputRightElement
          color="gray.500"
          children={<CalendarIcon fontSize="sm" />}
        />
      </InputGroup>
    </>
  );
};

const TestPage = () => {
  return (
    <Box>
      <DatePicker2 />
    </Box>
  );
};

export default TestPage;
